import { render, staticRenderFns } from "./o-notifications-api.vue?vue&type=template&id=4db512e0&scoped=true&"
import script from "./o-notifications-api.vue?vue&type=script&lang=js&"
export * from "./o-notifications-api.vue?vue&type=script&lang=js&"
import style0 from "./o-notifications-api.vue?vue&type=style&index=0&id=4db512e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db512e0",
  null
  
)

export default component.exports